import { useMutation } from "react-query-v4";
import ResourcesAPI from "../ResourcesAPI";

export const useSortByReorder = (config = {}) => {
  return useMutation({
    mutationFn: ({ payload, departmentId, parentSectionId }) =>
      ResourcesAPI.sortByReorder(payload, departmentId, parentSectionId),
    ...config,
  });
};

export const useAddSection = (config = {}) => {
  return useMutation({
    mutationFn: ({ payload, departmentId }) =>
      ResourcesAPI.addSection(payload, departmentId),
    ...config,
  });
};

export const useEditDepartment = (config = {}) => {
  return useMutation({
    mutationFn: ({ payload, departmentId }) =>
      ResourcesAPI.editDepartment(payload, departmentId),
    ...config,
  });
};

export const useEditSection = (config = {}) => {
  return useMutation({
    mutationFn: ({ payload, departmentId }) =>
      ResourcesAPI.editSection(payload, departmentId),
    ...config,
  });
};

export const useDeleteSection = (config = {}) => {
  return useMutation({
    mutationFn: ({ payload, departmentId }) =>
      ResourcesAPI.deleteSection(payload, departmentId),
    ...config,
  });
};

export const useAddResource = (config = {}) => {
  return useMutation({
    mutationFn: ({ payload, departmentId }) =>
      ResourcesAPI.addResource(payload, departmentId),
    ...config,
  });
};

export const useEditResource = (config = {}) => {
  return useMutation({
    mutationFn: ({ payload, departmentId }) =>
      ResourcesAPI.editResource(payload, departmentId),
    ...config,
  });
};

export const useDeleteResource = (config = {}) => {
  return useMutation({
    mutationFn: ({ payload, departmentId }) =>
      ResourcesAPI.deleteResource(payload, departmentId),
    ...config,
  });
};

export const useFavoriteResource = (config = {}) => {
  return useMutation({
    mutationFn: (payload) => ResourcesAPI.favoriteResource(payload),
    ...config,
  });
};

export const useUnfavoriteResource = (config = {}) => {
  return useMutation({
    mutationFn: (payload) => ResourcesAPI.unfavoriteResource(payload),
    ...config,
  });
};

export const useAddContactList = (config = {}) => {
  return useMutation({
    mutationFn: ({ payload, departmentId }) =>
      ResourcesAPI.addContactList(payload, departmentId),
    ...config,
  });
};

export const useEditContactList = (config = {}) => {
  return useMutation({
    mutationFn: ({ payload, departmentId }) =>
      ResourcesAPI.editContactList(payload, departmentId),
    ...config,
  });
};

export const useDeleteContactList = (config = {}) => {
  return useMutation({
    mutationFn: ({ contactListPayload, departmentId }) =>
      ResourcesAPI.deleteContactList(contactListPayload, departmentId),
    ...config,
  });
};
